







































































































































































































































































































































import { apiPageConfigGetStateContentByApp as _apiPageConfigGetStateContentByApp } from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApiPlus } from '@/hooks'
import { loadResource, LoadResourceUrlType } from 'vtils'
import { requiredDeep, Track } from '@/utils'

const apiPageConfigGetStateContentByApp = _apiPageConfigGetStateContentByApp

// const apiPageConfigGetStateContentByApp: typeof _apiPageConfigGetStateContentByApp =
//   ((data: any) =>
//     _apiPageConfigGetStateContentByApp({
//       ...data,
//       stateId: '8aaa8549801e16a701805fd29c910ad3',
//     }).then(res => ({
//       ...res,
//       list: [...(res.list as any), ...(res.list as any)],
//     }))) as any

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '七夕活动',
        }))
      }

      shareParams = {
        title: '七夕吃喝玩乐特惠',
        desc: '任意下单满300元即送猫眼石银饰手链一条',
        cover: 'https://cdn-resource.gogpay.cn/npm/_/16590755680vg2gU.jpg',
      }

      loading = computed(() => this.apiData.loading)

      currentBannerIndex = ref(0)

      apiData = useApiPlus({
        配置数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201823ecd9381015f',
            pageIndex: 1,
            pageSize: 7,
          })
            .then(requiredDeep)
            .then(res => res.list)
            .then(async list => {
              await loadResource({
                path: list[0].icon,
                type: LoadResourceUrlType.img,
              })
              return list
            }),
        推荐数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201823ed23aa30163',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list),
        精选推荐数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201823ee14e14017c',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list.slice(0, 3)),
        心动礼物数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201823eeb16520194',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list.slice(0, 9)),
        心动礼物分类数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201824257768701b7',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list.slice(0, 3)),
        甜蜜时光数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201824261cc3901c1',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list.slice(0, 9)),
        浪漫一刻数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa862c81dd25c201824269ce3401ca',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res => res.list.slice(0, 9)),
      })

      配置数据 = computed(() => ({
        头图: this.apiData.data.配置数据[0],
        精选推荐标题: this.apiData.data.配置数据[1],
        心动礼物标题: this.apiData.data.配置数据[2],
        甜蜜时光标题: this.apiData.data.配置数据[3],
        甜蜜时光更多: this.apiData.data.配置数据[4],
        浪漫一刻标题: this.apiData.data.配置数据[5],
        浪漫一刻更多: this.apiData.data.配置数据[6],
      }))

      推荐数据 = computed(() => this.apiData.data.推荐数据)

      精选推荐数据 = computed(() => this.apiData.data.精选推荐数据)

      心动礼物数据 = computed(() => this.apiData.data.心动礼物数据)

      心动礼物分类数据 = computed(() => this.apiData.data.心动礼物分类数据)

      甜蜜时光数据 = computed(() => this.apiData.data.甜蜜时光数据)

      浪漫一刻数据 = computed(() => this.apiData.data.浪漫一刻数据)
    },
)
